import styled from '@emotion/styled';
import Spinner from '@/components/@IntranetLibrary/Spinner';
import { CSSProperties } from 'react';

type P = {
  isUploading: boolean;
  title: string;
  style?: CSSProperties;
  onClick?: () => void;
  onMouseEnter?: () => void;
  onmouseleave?: () => void;
};
const UploadButton = ({
  onClick,
  isUploading,
  title,
  style,
  onMouseEnter,
  onmouseleave,
}: P) => {
  return (
    <StyledButton
      type={'button'}
      disabled={isUploading}
      style={{ ...style }}
      onClick={onClick}
      onMouseEnter={onMouseEnter}
      onMouseLeave={onmouseleave}
    >
      {isUploading ? <Spinner theme={'white'} /> : title}
    </StyledButton>
  );
};
export default UploadButton;

const StyledButton = styled.button`
  font-size: 14px;
  font-weight: 400;
  line-height: 20px;
  border-radius: 4px;
  border: 1px solid var(--dk-line, #e7e9ec);
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 8px 12px;
  white-space: nowrap;
  :disabled {
    background-color: var(--dk-bg-strong, #e7e9ec);
  }
  :hover {
    opacity: 0.8;
  }
`;
